module.exports = __webpack_public_path__ + "static/media/BACA.30240aad.jpg";